<article *ngIf="show" class="bl-padding-x--16 bl-padding-x-lg--40">
  <div
    id="post-app-status-card"
    class="dx-postapp-max-width bl-display--flex bl-align-items--flex-start bl-bg-color--white bl-border-radius--8 bl-padding--16 bl-margin-bottom--32 bl-position--relative bl-box-shadow"
  >
    <!-- <i *ngIf="!isWaiting" [class.cu-phone]="isFailed" 
      [class.bl-font-color--warning]="isFailed" [class.bl-font-color--success]="isSuccess" [class.cu-check-circle-solid]="isSuccess" class="bl-margin-right--16 bl-font-size--24 bl-margin-bottom--auto"></i> -->
    <div id="status-content" class="bl-flex--auto bl-display--flex bl-align-items--flex-start">
      <!-- Text content -->
      <div class="bl-flex--auto bl-display--flex bl-flex-direction--column bl-padding--8 bl-margin-top--auto bl-margin-bottom--auto">
        <header class="bl-font-size--22 bl-font-color--black bl-font-weight--900">
          <ng-container *ngIf="isWaiting">{{ 'hangtight/waitingHeading' | dictionary }}</ng-container>
          <ng-container *ngIf="isSuccess">{{ 'hangtight/successHeading' | dictionary }}</ng-container>
          <ng-container *ngIf="isInitiated">{{ 'hangtight/initiatedHeding' | dictionary }}</ng-container>
          <ng-container *ngIf="isFailed">{{ 'hangtight/failedHeading' | dictionary }}</ng-container>
        </header>
        <p *ngIf="isInitiated || isFailed" class="bl-font-color--steel bl-margin-bottom--0 bl-margin-bottom--4">
          <ng-container *ngIf="isInitiated">{{ 'hangtight/initiatedMsg' | dictionary }}</ng-container>
          <span *ngIf="isFailed" [innerHtml]="getContactmessage"></span>
        </p>
      </div>
      <!-- Icon -->
      <ea-svg
        *ngIf="type"
        [svgClass]="'status-' + type + ' bl-margin-bottom--0 bl-margin-x--16 bl-margin-y--8'"
        svgDescription="decision status icon"
        minWidth="56px"
        minHeight="56px"
        width="56px"
        height="56px"
      >
      </ea-svg>
    </div>

    <!-- Close button -->
    <button *ngIf="isSuccess" type="button" (click)="close()" aria-label="Close status update">
      <i class="cu-close bl-font-size--18"></i>
    </button>
  </div>
</article>
